import { GET_COUNTRIES_LIST, GET_PROVINCES, GET_CALLBACK_PAYMENT, GET_LINK_PARAMS } from '@plugins/service/api/urls'
import { COUNTRIES_LIST } from '@plugins/service/cache-timer'
import { checkStatus } from '@helper/utils'
import { CLEAR_DATA, SET_COUNTRIES_LIST } from './mutation-types'
export async function getCountries ({ commit }) {
  try {
    const { data, status } = await this.$api.index({
      url: GET_COUNTRIES_LIST,
      useCache: COUNTRIES_LIST
    })
    if (checkStatus(status)) {
      commit(SET_COUNTRIES_LIST, data)
      return data
    }
  } catch (error) {
    this.$logger.captureException({ error })
  }
}
export function clearData ({ commit }) {
  commit(CLEAR_DATA)
}
export function provinceListAction ({ commit }, query) {
  return this.$api.index({
    url: GET_PROVINCES,
    query
  })
}
export async function getData ({ commit }, query = {}) {
  // sort = DESC || ASC || null
  const { url = '', per_page = 8, page = 1, sort = null, status = null } = query
  try {
    const res = await this.$api.index({
      url,
      query: {
        per_page,
        page,
        sort,
        type: status
      }
    })
    return Promise.resolve(res)
  } catch (error) {
    this.$logger.captureException({ error })
    return Promise.reject(error)
  }
}
export function getInvoice ({ commit }, { uuid, query }) {
  let dataQuery = {}
  if (query) {
    dataQuery = {
      ...query
    }
  }
  return this.$api.index({
    url: GET_CALLBACK_PAYMENT({ uuid }),
    query: dataQuery
  })
}
export async function getLinkParameters ({ commit }, { course_id, zn_city_id, course_group_id }) {
  try {
    const { data, status } = await this.$api.index({
      url: GET_LINK_PARAMS,
      query: {
        course_id,
        zn_city_id,
        course_group_id
      }
    })
    if (checkStatus(status)) {
      return data
    }
  } catch (error) {
    this.$logger.captureException({ error })
  }
}
